// /store/slices/notifications.slice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAllEstudiantes } from "../../services/estudiante.service";

export const fetchOneCreditNotifications = createAsyncThunk(
  "notifications/fetchOneCredit",
  async () => {
    const allStudents = await getAllEstudiantes();
    const oneCreditNotifications = allStudents
      .filter((st) => st.estudiante?.credito === 1)
      .map((st) => {
        const nombre = st.persona?.nombre ?? "N/A";
        const apellido = st.persona?.apellido ?? "";
        const grupo = st.registro?.grupo?.nombre ?? "Sin grupo";
        return {
          id: `notif-${st.estudiante.idEstudiante}`,
          message: `El estudiante ${nombre} ${apellido} del grupo ${grupo} tiene solo 1 crédito restante.`,
          read: false, // ← Campo para indicar si está leído o no
          fecha: new Date().toISOString(), 
        };
      });
    return oneCreditNotifications;
  }
);

const notificationsSlice = createSlice({
  name: "notifications",
  initialState: {
    items: [],
  },
  reducers: {
    clearNotifications(state) {
      state.items = [];
    },

    // Marcar 1 notificación como leída
    markNotificationAsRead(state, action) {
      const notifId = action.payload;
      const notif = state.items.find((n) => n.id === notifId);
      if (notif) {
        notif.read = true;
      }
    },

    // Marcar todas como leídas
    markAllAsRead(state) {
      state.items.forEach((notif) => {
        notif.read = true;
      });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchOneCreditNotifications.fulfilled, (state, action) => {
      state.items = action.payload;
    });
  },
});

export const {
  clearNotifications,
  markNotificationAsRead,
  markAllAsRead,
} = notificationsSlice.actions;
export default notificationsSlice.reducer;
